import type { ReactNode } from 'react'
import { Icon, type IconName } from './icon'

type Props = {
  icon?: IconName
  title: string
  body?: ReactNode
  action?: ReactNode
}

export function EmptyState({ icon = 'inbox', title, body, action }: Props) {
  return (
    <div className="empty">
      <span className="empty-icon">
        <Icon name={icon} size={18} />
      </span>
      <div className="empty-title">{title}</div>
      {body && <div className="empty-body">{body}</div>}
      {action}
    </div>
  )
}
